import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "message-forwarder" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RoomSelector = _resolveComponent("RoomSelector")
  const _component_IconCheck = _resolveComponent("IconCheck")
  const _component_NcEmptyContent = _resolveComponent("NcEmptyContent")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_NcDialog = _resolveComponent("NcDialog")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$setup.showForwardedConfirmation)
      ? (_openBlock(), _createBlock(_component_RoomSelector, {
          key: 0,
          "show-postable-only": "",
          "allow-federation": "",
          "dialog-title": $options.dialogTitle,
          "dialog-subtitle": $options.dialogSubtitle,
          onSelect: $options.setSelectedConversationToken,
          onClose: $options.handleClose
        }, null, 8, ["dialog-title", "dialog-subtitle", "onSelect", "onClose"]))
      : (_openBlock(), _createBlock(_component_NcDialog, {
          key: 1,
          name: $options.dialogTitle,
          "close-on-click-outside": "",
          "onUpdate:open": $options.handleClose
        }, {
          actions: _withCtx(() => [
            _createVNode(_component_NcButton, {
              variant: "tertiary",
              onClick: $options.handleClose
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($options.t('spreed', 'Dismiss')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_NcButton, {
              variant: "primary",
              onClick: $options.openConversation
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($options.t('spreed', 'Go to conversation')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_NcEmptyContent, {
              description: $options.t('spreed', 'The message has been forwarded to {selectedConversationName}', { selectedConversationName: $setup.selectedConversationName })
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_IconCheck, { size: 64 })
              ]),
              _: 1
            }, 8, ["description"])
          ]),
          _: 1
        }, 8, ["name", "onUpdate:open"]))
  ]))
}